import _bStatcounter from "./../../levels/common.blocks/b-statcounter/b-statcounter.react.js";

var BStatcounter = _bStatcounter.applyDecls();

import "./../../levels/common.blocks/b-statcounter/b-statcounter.css";


export default BStatcounter;